type ambiguousFunction = (...args: any[]) => void;

interface Events {
    [key: string]: Array<ambiguousFunction>
}

export default class PubSub {
    events: Events;
    constructor() {
        this.events = {};
    }
    // 订阅
    subscribe(event: string, func: ambiguousFunction) {
        this.events[event] = this.events[event] || [];
        this.events[event].push(func);
    }
    // 发布
    publish(event: string, ...args: any[]) {
        this.events[event] && this.events[event].length && this.events[event].forEach(func => func(...args));
    }
    // 取消订阅
    unsubscribe(event: string, func: ambiguousFunction) {
        if (this.events[event]) {
            const funcIndex = this.events[event].findIndex(item => item === func);
            if (funcIndex !== -1) {
                this.events[event].splice(funcIndex, 1);
            }
        }
        if (this.events[event].length === 0) {
            delete this.events[event];
        }
    }
    // 取消该事件的所有执行
    unsubscribeAll(event: string) {
        this.events[event] && (delete this.events[event]);
    }

    // 取消所有事件的所有执行
    unsubscribeAllEvent() {
        // console.log(this.events);
        Object.keys(this.events).forEach(event => {
            delete this.events[event]
        });
        // console.log(this.events);
    }
}

export const publicPubsub = new PubSub();